import * as React from 'react';
import TextContainer from '../components/text-container';
import ImageWithFocus from '../components/image-with-focus';
import { TImprovedContentMarketing } from '../../../../shared/types/contentMarketing';

type TVerticalContentMarketingBlock = {
    contentMarketing: TImprovedContentMarketing;
    isMultipleAds: boolean;
    noPadding?: boolean;
    hasImageRadius?: boolean;
};

const VerticalBlock = ({
    contentMarketing,
    isMultipleAds,
    noPadding,
    hasImageRadius,
}: TVerticalContentMarketingBlock) => {
    return (
        <div data-testid={'cm-vertical-block'} className={'flex flex-col'}>
            <ImageWithFocus
                hasImageRadius={hasImageRadius}
                alt="Annonsebilde"
                contentMarketing={contentMarketing}
                isMultipleAds={isMultipleAds}
            />
            <div className={noPadding ? 'py-8' : 'px-16 pt-8 pb-16'}>
                <TextContainer
                    smallText={false}
                    contentMarketing={contentMarketing}
                />
            </div>
        </div>
    );
};

export default VerticalBlock;
